import Conexion_api from "@/api/Conexion_api.js";
import manejador_push from "@/funciones/push/manejador_push";
import redireccionar from "@/funciones/redireccionar";
import obtener_configuracion_contrasena from "@/funciones/obtener_configuracion_contrasena";
import obtener_contrasenia_usuario from "@/funciones/obtener_contrasenia_usuario";

const seleccionar = async function(distribuidor, distribuidores, enlace = null, respuesta_modal = null, distribuidor_modal = null, cookie = null) {
  if (respuesta_modal && distribuidor_modal && cookie) {
    this.loader_login = false;
    continuar_ejecuacion(respuesta_modal, distribuidor_modal, distribuidores, enlace, this.usuario, cookie);
    return
  }
  let respuesta = await Conexion_api({
    body: {
      correo: this.usuario.correo,
      distribuidora: distribuidor.base,
      nombre_distribuidora: distribuidor.nombre_distribuidor,
    },
    evento: "login/generar_token",
  }).catch((err) => {
    err = String(err);
    this.$root.$emit("snackbar", { color: "error", texto: err });
    console.error(err);
    return;
  });

  if (respuesta.data.error) {
    this.$root.$emit("snackbar", {
      color: "error",
      texto: respuesta.data.error,
    });
    return;
  }
  distribuidor.contrasenia = false;
  distribuidor.contrasenia_usuario = null;

  this.obtener_config = obtener_configuracion_contrasena.bind(this);
  await this.obtener_config(distribuidor)

  this.obtener_contrasenia = obtener_contrasenia_usuario.bind(this);
  await this.obtener_contrasenia(distribuidor, this.usuario.rut);
  if (distribuidor.contrasenia && distribuidor.contrasenia_usuario) {
    this.token = respuesta;
    this.distribuidor = distribuidor;
    this.distribuidores = distribuidores;
    this.contrasenia = distribuidor.contrasenia_usuario;
    this.enlace = enlace;
    this.modal_contrasenia = true;
    return
  }else continuar_ejecuacion(respuesta, distribuidor, distribuidores, enlace, this.usuario, this.$cookie);
}

async function continuar_ejecuacion(respuesta, distribuidor, distribuidores, enlace, usuario, cookie) {
  /**
   * SE LANZA PETICIÓN PARA PERMITIR NOTIFICACIONES,
   * SI YA ESTA ACTIVO, CAMBIA AL DISTRIBUIDOR SELECCIONADO
   */
  let bases = distribuidores.map((el) => el.base);
  localStorage.setItem("dbs", bases);

  let notificaciones = await manejador_push({ base: distribuidor.base, email: usuario.correo, bases: distribuidores});
  if (notificaciones)
    this.$root.$emit("snackbar", {
      color: "#4CAF50",
      texto: notificaciones,
    });
  cookie.set("pwst", respuesta.data.token, { expires: "1h" });
  if(enlace) redireccionar(`/${enlace}`);
  else redireccionar(`/pedidos_web`);
  return;
}

export default seleccionar